module.exports = __webpack_public_path__ + "img/sbl0011.4a1d9096.png";